module.exports = __webpack_public_path__ + "static/media/CTLA_3-135w.49fcdc92.jpg";